<template>
  <div class="modal_wrap timePickerModal" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">{{ isTitle }}</h1>
        </div>
        <div class="modal_con">
          <div class="slide_hour slide_time">
            <Swiper
              :options="swiperOption"
              ref="hourSwiper"
              @slideChange="slideChangeTransitionHour"
            >
              <SwiperSlide v-for="(item, index) in timeHour" :key="index">
                <div class="time_txt">{{ item }}</div></SwiperSlide
              >
            </Swiper>
            <div class="vizor"></div>
          </div>
          <div>
            <img src="@/assets/front/images/new/i_timepicker_dot.svg" alt="" />
          </div>
          <div class="slide_minute slide_time">
            <Swiper
              :options="swiperOption2"
              ref="minuteSwiper"
              @slideChange="slideChangeTransitionMinute"
            >
              <SwiperSlide v-for="(item, index) in timeMinute" :key="index">
                <div class="time_txt">{{ item }}</div></SwiperSlide
              >
            </Swiper>
            <div class="vizor"></div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <button class="btn" @click="$emit('selectTime')">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

// Import Swiper styles
import 'swiper/swiper.scss';
export default {
  name: 'TimePickerModal',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      isOpen: false,
      isTitle: '',
      isTimeSet: '', // start : 시작 시각, end : 종료 시각
      hourStart: '10',
      minuteStart: '00',
      hourEnd: '20',
      minuteEnd: '00',
      timeHour: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
      ],
      timeMinute: ['00', '30'],
      swiperOption: {
        // loop: true,
        // autoplay: {
        //   delay: 3000,
        // },
        // speed: 2500,
        pagination: '.swiper-pagination',
        slidesPerView: 3,
        freeMode: true,
        freeModeSticky: true,
        freeModeMomentumRatio: 0.25,
        freeModeVelocityRatio: 0.25,
        freeModeMinimumVelocity: 0.1,
        mousewheelControl: true,
        mousewheelSensitivity: 0.5,
        loop: false,
        loopAdditionalSlides: 5,
        direction: 'vertical',
        slideToClickedSlide: true,
        centeredSlides: true,
      },
      swiperOption2: {
        // loop: true,
        // autoplay: {
        //   delay: 3000,
        // },
        // speed: 2500,
        pagination: '.swiper-pagination',
        slidesPerView: 3,
        freeMode: true,
        freeModeSticky: true,
        freeModeMomentumRatio: 0.25,
        freeModeVelocityRatio: 0.25,
        freeModeMinimumVelocity: 0.1,
        mousewheelControl: true,
        mousewheelSensitivity: 0.5,
        loop: false,
        loopAdditionalSlides: 5,
        direction: 'vertical',
        slideToClickedSlide: true,
        centeredSlides: true,
      },
    };
  },
  computed: {
    hourSwiper() {
      return this.$refs.hourSwiper.$swiper;
    },
    minuteSwiper() {
      return this.$refs.minuteSwiper.$swiper;
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        if (this.isTimeSet == 'start') {
          this.hourSwiper.slideTo(10, 10, false);
          this.minuteSwiper.slideTo(0, 10, false);
          this.hourStart = '10';
          this.minuteStart = '00';
        } else {
          this.hourSwiper.slideTo(20, 10, false);
          this.minuteSwiper.slideTo(0, 10, false);
          this.hourEnd = '20';
          this.minuteEnd = '00';
        }
      }
    },
  },
  created() {
    // alert(1);
    // this.hourSwiper.slideTo(9, 1000, false); // 10시 default
  },
  mounted() {
    // alert(1);
    // console.log('Current Swiper instance object', this.swiper);
    this.hourSwiper.slideTo(9, 1000, false); // 10시 default
  },
  methods: {
    slideChangeTransitionHour() {
      console.log(this.hourSwiper.activeIndex); //현재 index값 얻기
      const selHour = this.timeHour[this.hourSwiper.activeIndex];
      console.log('hour');
      console.log(selHour);
      if (this.isTimeSet == 'start') {
        this.hourStart = selHour;
      } else {
        this.hourEnd = selHour;
      }
    },
    slideChangeTransitionMinute() {
      console.log(this.minuteSwiper.activeIndex); //현재 index값 얻기
      const selMinute = this.timeMinute[this.minuteSwiper.activeIndex];
      console.log('minute');
      console.log(selMinute);

      if (this.isTimeSet == 'start') {
        this.minuteStart = selMinute;
      } else {
        this.minuteEnd = selMinute;
      }
    },
  },
};
</script>
